import clsx from 'clsx';
import { TruncatedText } from '../../../../shared/ui/truncated-text';
import styles from './TemplateIdLabel.module.css';

export function TemplateIdLabel({ templateId, className }) {
  if (templateId == null || templateId === '') {
    return null;
  }

  return (
    <TruncatedText
      className={clsx(styles.label, className)}
      truncatedClassName={styles.labelTruncated}
      triggerClassName={styles.trigger}
    >
      {/* Non-breaking space: keeps "ID:" from wrapping onto its own line in the tooltip. */}
      {`ID:\u00A0${templateId}`}
    </TruncatedText>
  );
}
